import { render, staticRenderFns } from "./DateStartOf.vue?vue&type=template&id=683b0639&scoped=true"
import script from "./DateStartOf.vue?vue&type=script&lang=js"
export * from "./DateStartOf.vue?vue&type=script&lang=js"
import style0 from "./DateStartOf.vue?vue&type=style&index=0&id=683b0639&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "683b0639",
  null
  
)

export default component.exports